import { CheckCircle2, Smartphone } from 'lucide-react';
import AuthStatusLayout from './components/auth/AuthStatusLayout';
import { buildAppOpenUrl } from './lib/authUrls';

export default function EmailConfirmedPage() {
  return (
    <AuthStatusLayout
      tone="success"
      title="Email confirmed"
      statusLabel="Account activated"
      icon={<CheckCircle2 size={18} />}
      actions={[
        {
          label: 'Open app',
          href: buildAppOpenUrl(),
          external: true,
          variant: 'primary',
          icon: <Smartphone size={18} />,
        },
      ]}
    />
  );
}
